import { render, staticRenderFns } from "./buildDetails.vue?vue&type=template&id=993cbcb6&scoped=true"
import script from "./buildDetails.vue?vue&type=script&lang=js"
export * from "./buildDetails.vue?vue&type=script&lang=js"
import style0 from "./buildDetails.vue?vue&type=style&index=0&id=993cbcb6&prod&lang=scss&scoped=true"
import style1 from "./buildDetails.vue?vue&type=style&index=1&id=993cbcb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993cbcb6",
  null
  
)

export default component.exports